{
  "OrganizationTalentsPage": {
    "title": "组织人才"
  },
  "ResourceTypesSettingsMenu": {
    "triggerLabel": "配置资源类型",
    "heading": "配置资源类型",
    "allTypes": "全部类型",
    "global": "在此组织",
    "workspace": "在此工作区",
    "thisTypeInWorkspace": "此工作区中的 {{name}}"
  },
  "ResourceRowGallery": {
    "failedToLoad": "加载 Pin 失败",
    "empty": "暂无 Pin",
    "addContactPins": "添加 Pin",
    "label": "Pin"
  },
  "AssignResourcesToWorkspacesDialog": {
    "title": "分配到工作区",
    "description_one": "选择 {{name}} 在工作区中的可见性。",
    "description_other": "选择这 {{count}} 个资源在工作区中的可见性。",
    "fieldScope": "可见性",
    "scopeHidden": "隐藏",
    "scopeHiddenHint": "无工作区成员关系 — 不出现在任何列表中（仅管理员）。",
    "scopeGlobal": "全局",
    "scopeGlobalHint": "在每个工作区可见（成员关系行的工作区 id 为空）。",
    "scopeWorkspaces": "指定工作区",
    "fieldWorkspaces": "工作区",
    "workspacesSelectPrompt": "选择一个或多个工作区",
    "workspacesSelectedCount": "已选 {{count}} 个",
    "workspacesUnselectAll": "取消全选",
    "workspacesEmpty": "暂无可用工作区",
    "save": "分配",
    "assignFailed": "分配工作区失败",
    "unsavedChangesBeforeUnload": "您有未保存的更改！",
    "success_one": "资源已分配到工作区",
    "success_other": "已将 {{count}} 个资源分配到工作区"
  },
  "ResourceWorkspacesCell": {
    "hidden": "隐藏",
    "global": "全局"
  },
  "ResourceCreateForm": {
    "profilePicture": "头像",
    "resourceType": "资源类型"
  },
  "ResourceCreateDialog": {
    "title": "创建资源",
    "titleTypeAndVisibility": "创建资源 · 类型和可见性",
    "titleType": "创建资源 · 类型",
    "titleDetails": "创建资源 · 详情",
    "description": "创建新资源",
    "actions": {
      "add-another": "保存并继续添加",
      "go-to-profile": "保存并前往个人资料",
      "close": "保存"
    },
    "createFailed": "创建资源失败",
    "noResourceTypes": "没有可用的资源类型。"
  },
  "CreateDraftSummary": {
    "change": "更改"
  },
  "ResourceDuplicatesFooter": {
    "title": "看起来眼熟？",
    "titleExact": "已存在同名资源",
    "summary_other": "{{count}} 个现有资源名称相似",
    "summaryNamed_other": "{{count}} 个现有资源与“{{name}}”相似",
    "review": "查看",
    "hide": "收起",
    "dismiss": "忽略",
    "exactMatch": "同名",
    "similarMatch": "相似",
    "openProfile": "打开",
    "openProfileOf": "在新标签页中打开 {{name}} 的资料",
    "hint": "资料会在新标签页中打开，草稿会保留在这里。不是同一个人？直接保存即可。"
  },
  "ResourceSchema": {
    "coreLabel": {
      "fullName": "全名",
      "pronouns": "代词",
      "emails": "电子邮箱",
      "phoneNumbers": "电话号码",
      "socials": "社交媒体",
      "websites": "网站",
      "tags": "标签",
      "groups": "分组",
      "locations": "地点",
      "rates": "费率",
      "agent": "经纪人",
      "organization": "机构",
      "nickname": "昵称",
      "role": "角色"
    },
    "enterPlaceholder": "输入{{label}}",
    "globalSection": "全局",
    "emptyWorkspaceSection": "{{workspaceName}} 没有专属字段",
    "locationItemTitle": "地点",
    "rateItemTitle": "费率",
    "addRate": "添加费率",
    "blankRate": "空白费率",
    "blankRateHint": "输入金额",
    "fromRateCard": "从费率卡添加",
    "addItem": "添加{{name}}"
  },
  "ResourceEditorVersionSwitch": {
    "title": "资源编辑器",
    "newVersionDescription": "你正在试用新编辑器。它仍处于实验阶段——如有问题，可切换回经典版。你的数据不会改变。",
    "oldVersionDescription": "你正在使用经典编辑器。新编辑器处于测试阶段——随时可以试用。"
  },
  "ResourceNotesPanel": {
    "title": "备注",
    "fieldLabel": "新备注",
    "placeholder": "写一条备注…",
    "submit": "添加备注",
    "emptyTitle": "暂无备注",
    "emptyDescription": "记录关于 {{name}} 的备注。",
    "fallbackName": "此资源",
    "loadError": "无法加载备注。",
    "unknownUser": "未知用户",
    "deleteAria": "删除备注",
    "createdToast": "备注已添加",
    "createErrorToast": "无法添加备注",
    "deletedToast": "备注已删除",
    "deleteErrorToast": "无法删除备注"
  },
  "ResourceFilesPanel": {
    "title": "文档",
    "emptyTitle": "暂无文档",
    "emptyDescription": "管理 {{name}} 的重要文档和文件。",
    "fallbackName": "此资源",
    "loadError": "无法加载文档。",
    "untitled": "未命名文件",
    "uploadedToast": "文件已上传",
    "uploadErrorToast": "上传失败",
    "reorderErrorToast": "无法保存新的顺序"
  },
  "ResourcePane": {
    "invalidDataDescription": "我们仍会显示此表单，但它可能无法正常工作。如遇问题，请联系支持。"
  },
  "Pinboard": {
    "title": "图板",
    "addPins": "添加图钉",
    "filterByTag": "按标签筛选",
    "tags": "标签",
    "countFiltered_other": "{{count}} / {{total}} 个图钉",
    "noMatchesTitle": "没有图钉匹配这些标签",
    "noMatches": "试试其他标签，或清除筛选以查看所有图钉。",
    "emptyReadOnly": "图钉用于展示此人的作品示例和重要信息。",
    "loading": "正在加载图钉",
    "toast": {
      "undo": "撤销",
      "added": "已添加图钉",
      "addFailed": "无法添加图钉",
      "addedMany_other": "已添加 {{count}} 个图钉",
      "addedPartly": "已添加 {{added}} 个，{{failed}} 个失败",
      "addFailedMany_other": "无法添加 {{count}} 个图钉",
      "deleted_other": "已删除 {{count}} 个图钉",
      "deleteFailed_other": "无法删除 {{count}} 个图钉",
      "updated": "已更新图钉",
      "updateFailed": "无法更新图钉",
      "profilePictureSaved": "已保存头像",
      "profilePictureFailed": "无法设置头像",
      "reorderFailed": "无法保存新的顺序"
    },
    "card": {
      "untitled": "未命名",
      "actions": "{{name}} 的操作",
      "editTags": "编辑标签",
      "setAsProfilePicture": "设为头像",
      "download": "下载",
      "openLink": "打开链接",
      "delete": "删除图钉"
    },
    "add": {
      "title": "添加图钉",
      "description": "图片、视频、文档和链接，显示在图板上。",
      "formats": "图片、视频、PDF 和其他文件 · 按 ⌘V 粘贴",
      "orAddLink": "或添加链接"
    },
    "link": {
      "hint": "图片、YouTube 或 Vimeo 视频，或任何网页。",
      "notAUrl": "不是链接",
      "notAUrlHint": "粘贴一个地址，例如 https://example.com/photo.jpg。",
      "brokenPicture": "图片无法加载",
      "brokenPictureHint": "检查地址，或下载图片后上传。",
      "missingVideo": "未找到视频",
      "missingVideoHint": "请确认视频存在且为公开。",
      "page": "网页"
    },
    "pin": "个图钉",
    "pins": "个图钉",
    "deleteSelected_other": "删除 {{count}} 个图钉"
  },
  "ResourceAside": {
    "title": "概览",
    "expand": "展开面板",
    "collapse": "收起面板",
    "fallbackName": "该资源",
    "heroNow": "当前：{{status}}",
    "heroUntil": "至 {{date}}",
    "heroNext": "接下来：{{status}}",
    "heroEmpty": "暂无安排",
    "heroEmptyDetail_other": "未来 {{count}} 天没有安排",
    "startsTomorrow": "明天",
    "startsInDays_other": "{{count}} 天后",
    "scheduleTitle": "日程",
    "scheduleAdd": "添加可用时间",
    "scheduleNow": "进行中",
    "scheduleEmpty": "记录 {{name}} 下次何时可用。",
    "scheduleCalendar": "打开日历",
    "scheduleCalendarMore_other": "打开日历 · 还有 {{count}} 项",
    "shortlistsTitle": "候选名单",
    "shortlistsAdd": "添加到候选名单",
    "shortlistsMenu": "候选名单操作",
    "shortlistsRemove": "从候选名单移除",
    "shortlistsEmpty": "{{name}} 被加入的候选名单将显示在这里。",
    "shortlistsError": "无法加载候选名单。",
    "previewError": "无法加载。",
    "notesTitle": "备注",
    "notesEmpty": "还没有关于{{name}}的备注。",
    "notesOpen": "打开备注",
    "documentsTitle": "文档",
    "documentsEmpty": "还没有{{name}}的文档。",
    "documentsOpen": "打开文档",
    "untitledFile": "未命名文件",
    "shortlistPublished": "已发布",
    "shortlistDraft": "草稿",
    "shortlistCount": "{{count}} 人入选"
  },
  "ContactPeopleList": {
    "title": "人员",
    "addResources": "添加资源",
    "addFirst": "添加第一位人员",
    "emptyTitle": "暂无人员",
    "noMatchTitle": "未找到人员",
    "emptyMessageOrganisation": "添加在该组织工作的人员。",
    "emptyMessageAgent": "添加该经纪人代理的人员。",
    "removeFromOrganisation": "从组织中移除",
    "removeFromAgent": "从经纪人中移除",
    "confirmOrganisation": "从该组织中移除所选人员？他们仍保留在联系人中。",
    "confirmAgent": "从该经纪人中移除所选人员？他们仍保留在联系人中。",
    "confirmRemove": "移除",
    "removedToast": "已移除 {{count}}。",
    "removedPartialToast": "已移除 {{removed}}。{{notLinked}} 未与此关联，已保持不变。",
    "removeFailedToast": "无法移除所选人员"
  },
  "ContactPeopleAddResources": {
    "title": "添加资源",
    "pick": "选入 {{name}}",
    "linked": "已关联",
    "noResults": "未找到资源",
    "noLinkableTypes": "此处没有可关联到 {{name}} 的资源类型。",
    "add": "添加到 {{name}}",
    "added_other": "已将 {{count}} 人添加到 {{name}}",
    "addFailed": "未能将所有人添加到 {{name}}，请重试。"
  }
}
